<template>
    <b-overlay :show="loading" rounded="sm">
        <div v-if="NameCardDetail" :class="['nc-tray', { 'nc-mobile': mobile }]">
            <!-- Title -->
            <div class="nc-title-row">
                <div class="nc-title-left">
                    <i v-if="mobile" class="nc-back" @click="$emit('close')">
                        <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Back_Arrow.svg" alt="返回" width="24" height="25" />
                    </i>

                    <div class="nc-title-line">
                        <span class="nc-title-text">{{ title }}</span>
                        <span class="nc-unread-chip" v-if="unread">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Unread") }}</span>
                    </div>
                </div>

                <div class="nc-title-right">
                    <span class="nc-received">{{ receivedOnText }}</span>
                    <span class="nc-ref" v-html="refText"></span>
                </div>
            </div>

            <!-- Unlock bar (Free booth only) - aligned with Direct Enquiries -->
            <div class="nc-unLock" v-if="['Guest'].includes(BoothType)">
                <unlockQuota_Free
                    Type="2"
                    unlockType="NameCard"
                    :user="user"
                    :rid="rid"
                    :mobile="mobile"
                    :simulatedSupplier="simulatedSupplier"
                    @unlockQuota="onNameCardUnlockQuota"
                />
            </div>

            <!-- Content -->
            <div class="nc-content">
                <div class="nc-content-inner">
                    <!-- Left: Master Form -->
                    <div class="nc-master">
                        <!-- Buyer Name Card -->
                        <div class="nc-section" >
                            <div class="nc-section-title">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_BuyerBusinessCard") }}</div>
                            <div class="nc-card">
                                <div class="nc-namecard-preview-wrap">
                                    <div class="nc-preview">
                                          <template>
                                            <div class="nc-preview-body">
                                                <div class="nc-preview-content">
                                                    <div>
                                                        <div class="nc-preview-name">{{ NameCardDetail.surname }}</div>
                                                        <div class="nc-preview-job" v-if="NameCardDetail.jobTitle">{{ NameCardDetail.jobTitle }}</div>
                                                    </div>
                                                    <div>
                                                        <div class="nc-preview-company" v-if="NameCardDetail.compname">{{ NameCardDetail.compname }}</div>
                                                        <div class="nc-preview-line" v-if="NameCardDetail.tel">{{ NameCardDetail.tel }}</div>
                                                        <div class="nc-preview-line nc-preview-email" v-if="NameCardDetail.email">{{ NameCardDetail.email }}</div>
                                                    </div>
                                                </div>
                                                <div class="nc-preview-buyer">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_BuyerTag") }}</div>
                                            </div>
                                        </template>

                                        <!-- Figma "View attachment" 60x60 thumbnail at bottom-right (slightly overhang) -->
                                        <div class="nc-preview-attach" v-if="NameCardDetail.nameCardImage">
                                            <img
                                                v-if="attachmentThumbSrc"
                                                :src="attachmentThumbSrc"
                                                alt="Attachment"
                                                class="nc-preview-attach-img"
                                                @click.stop.prevent="openNameCardImagePreview"
                                            />
                                            <div v-else class="nc-preview-attach-placeholder">
                                                <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Image_Placeholder.svg" alt="图片占位符" width="20" height="20" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <PhotoPreview v-model="isShowNameCardImageModal">
                                    <template slot="content">
                                        <img
                                            :src="nameCardImagePreviewUrl"
                                            alt="Name card preview"
                                        />
                                    </template>
                                </PhotoPreview>

                                <div class="nc-title-content" v-if="NameCardDetail.message">
                                    <div class="nc-title-content-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_MessageFromBuyer") }}</div>
                                    <div class="nc-title-content-body">{{ NameCardDetail.message }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Lead Source -->
                        <div class="nc-section" v-if="leadSourceProductName || leadSourceProductPhoto">
                            <div class="nc-section-title">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_LeadSource") }}</div>
                            <div
                                class="nc-card"
                                :class="{ 'nc-card--clickable': !!leadSourceTargetUrl }"
                                @click="openLeadSourceLink"
                            >
                                <div class="nc-product-row">
                                <div class="nc-product-thumb" :class="{ 'nc-product-thumb--company': isCompanyLead }">
                                        <img v-if="leadSourceProductPhoto" :src="leadSourceProductPhoto" :alt="NameCardDetail.productId ? 'Product' : 'Company'" />
                                        <span v-else-if="isCompanyLead && leadSourceCompanyFirstChar" class="nc-company-thumb-fallback">{{ leadSourceCompanyFirstChar }}</span>
                                    </div>
                                    <div class="nc-product-title">
                                        <span class="nc-product-title-text">{{ leadSourceProductName }}</span>
                                              <!-- CPS+ eMarketplace ProductInfo share link（根据语言+公司ID+产品ID 动态生成） -->
                                        <a v-if="NameCardDetail.productId && productShareUrl"
                                           :href="productShareUrl"
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           @click.stop
                                           :t_label="`EMP3_SalesLead_NameCard_ProductShare_${rid || 0}`">
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/open_in_new.svg" alt="分享" width="16" height="16" />
                                        </a>
                                        <a v-if="isCompanyLead && companyShareUrl"
                                           :href="companyShareUrl"
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           @click.stop
                                           :t_label="`EMP3_SalesLead_NameCard_CompanyShare_${rid || 0}`">
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/open_in_new.svg" alt="分享" width="16" height="16" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Your Actions -->
                        <div class="nc-section">
                            <div class="nc-section-title">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_YourActions_Company") }}</div>
                            <div class="nc-card">
                                <div class="nc-actions-row">
                                    <button
                                        v-if="isReplied  && !simulatedSupplier"
                                        class="nc-btn nc-btn-done"
                                        type="button"
                                        @click="openViewRepliedModal"
                                        :t_label="`EMP3_SalesLead_NameCard_OpenViewReplied_${rid || 0}`"
                                    >
                                        <span class="nc-btn-icon">
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Replied_Checkmark.svg" alt="已回复" width="20" height="20" />
                                        </span>
                                        <!-- repliedButtonText 内部会把“手机/邮箱”两个词加粗，需使用 v-html -->
                                        <span class="nc-btn-text" v-html="repliedButtonText"></span>
                                    </button>
                                    <button
                                        v-else-if="showReplyWithNameCardButton && !simulatedSupplier"
                                        class="nc-btn nc-btn-reply"
                                        type="button"
                                        @click="openSendNameCardModal"
                                        :t_label="`EMP3_SalesLead_NameCard_OpenReplyModal_${rid || 0}`"
                                    >
                                        {{ $t("lbl_EMPBE_SalesLead_ReplyWithNameCard") }}
                                    </button>
                                    <button
                                        v-else
                                        class="nc-btn nc-btn-reply nc-btn-reply-locked"
                                        type="button"
                                        disabled
                                        :t_label="`EMP3_SalesLead_NameCard_OpenReplyModal_Locked_${rid || 0}`"
                                    >
                                        <span class="nc-btn-icon">
                                            <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Lock.svg" alt="锁定" width="20" height="20" />
                                        </span>
                                        <span>{{ $t("lbl_EMPBE_SalesLead_ReplyWithNameCard") }}</span>
                                    </button>
                                    <span class="nc-actions-slash">/</span>
                                    <span class="nc-actions-tip" v-html="$t('lbl_EMPBE_SalesLead_NameCardPage_ContactDirectTip')"></span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Right: Contact Info -->
                    <div class="nc-contact">
                        <div class="nc-section-title">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_ContactInfo") }}</div>
                        <div class="nc-card nc-contact-card">
                            <div class="nc-contact-list">
                                <div class="nc-row" v-if="NameCardDetail.compname">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_ReportAll_Table_CompanyName") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.compname }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.surname">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_FullName") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.surname }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.jobTitle">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_JobTitle") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.jobTitle }}</div>
                                </div>
                                <div class="nc-row" v-if="countryName">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_CountryRegion") }}</div>
                                    <div class="nc-row-value">{{ countryName }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.tel">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_MobileNumber") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.tel }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.email">
                                    <div class="nc-row-label">{{ $t("Lbl_EmailAddress") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.email }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.whatsapp">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_WhatsApp") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.whatsapp }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.wechat">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_WeChat") }}</div>
                                    <div class="nc-row-value">{{ NameCardDetail.wechat }}</div>
                                </div>
                                <div class="nc-row" v-if="NameCardDetail.website">
                                    <div class="nc-row-label">{{ $t("lbl_EMPBE_SalesLead_Website") }}</div>
                                    <div class="nc-row-value">
                                        <a
                                            class="nc-link"
                                            :href="websiteHref"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            :t_label="`EMP3_SalesLead_NameCard_OpenWebsite_${rid || 0}`"
                                        >
                                            {{ NameCardDetail.website }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="nc-contact-foot">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_ProvidedViaBusinessCard") }}</div>
                        </div>
                    </div>
                </div>

            </div>
            

        </div>

        <div class="nc-section nc-section--remarks" v-if="rid">
                    <div class="nc-card nc-message-board-card">
                        <MessageThread
                            :key="'remarks-namecard-' + rid"
                            :source-type="'NameCard'"
                            :source-id="rid"
                            log-form-type-prefix="SalesleadBack_"
                            :simulated-supplier="!!simulatedSupplier"
                            :max-depth="5"
                            :allow-create="true"
                            :allow-reply="false"
                            :allow-delete="false"
                            :root-level-only="true"
                        />
                    </div>
                </div>

        <!-- Modal: Reply With Name Card (Figma node 2941:20482) -->
        <ModalTips :id="'SendNameCardModal'" v-model="showSendNameCardModal">
            <template v-slot:Title>
                <div class="nc-modal-title">
                    <div class="nc-modal-title-text">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_Title") }}</div>
                    <div class="nc-modal-subtitle">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_Subtitle") }}</div>
                </div>
            </template>

            <template v-slot:Content>
                <ValidationObserver ref="sendNameCardFormObserver" tag="div" class="nc-modal-body">
                    <div class="nc-modal-block">
                        <selection style="margin-bottom:0px !important;"
                            ControlId="ncContactPerson"
                            :title="$t('lbl_EMPBE_SalesLead_NameCardPage_Modal_SelectContact')"
                            :mandatory="$t('lbl_EMPBE_SalesLead_NameCardPage_Modal_SelectContact') + $t('lbl_IsRequire')"
                            v-model="selectedContactPerson"
                            :options="contactPersonOptions"
                            :enableValidation="contactPersonLoaded"
                            :disabled="contactPersonLoading"
                            :clearable="false"
                            :searchable="false"
                            :allowInput="false"
                            :appendToBody="true"
                            :zIndex="3000"
                        />
                        <div class="nc-modal-hint">
                            {{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_NoContactHint") }}<router-link
                                class="nc-modal-link"
                                :to="{ path: '/UserSetting/MyUsers' }"
                                target="_blank"
                                rel="noopener noreferrer"
                                :t_label="`EMP3_SalesLead_NameCard_GoUserManagement_${rid || 0}`"
                            >{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_UserManagement") }}</router-link>{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_NoContactHintSuffix") }}
                        </div>
                    </div>

                    <div class="nc-modal-preview-wrap">
                        <div class="nc-preview nc-preview-supplier">
                            <div class="nc-preview-body">
                                <div class="nc-preview-supplier-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_SupplierTag") }}</div>
                                <div class="nc-preview-content">
                                    <div>
                                        <div class="nc-preview-name" v-if="supplierCardName">{{ supplierCardName }}</div>
                                        <div class="nc-preview-job" v-if="supplierCardJob">{{ supplierCardJob }}</div>
                                    </div>
                                    <div>
                                        <div class="nc-preview-company" v-if="supplierCardCompany">{{ supplierCardCompany }}</div>
                                        <div class="nc-preview-line" v-if="supplierCardMobile">{{ supplierCardMobile }}</div>
                                        <div class="nc-preview-line nc-preview-email" v-if="supplierCardEmail">{{ supplierCardEmail }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <router-link
                            v-if="isSelectedContactPersonMyAccount"
                            class="nc-edit-link"
                            :to="{ path: '/UserSetting/MyAccount' }"
                            :t_label="`EMP3_SalesLead_NameCard_GoMyAccount_${rid || 0}`"
                        >
                            <span class="nc-edit-icon">
                                <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Edit.svg" alt="编辑" width="14" height="14" />
                            </span>
                            <span>{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_EditCardInfo") }}</span>
                        </router-link>
                    </div>

                    <div class="nc-modal-block">
                        <!-- <div class="nc-modal-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_MessageOptional") }}</div> -->
                        <customtextarea
                            :placeholder="$t('lbl_EMPBE_SalesLead_NameCardPage_Modal_MessageOptional')"
                            ControlId="ncMessageToBuyer"
                            :title="$t('lbl_EMPBE_SalesLead_NameCardPage_Modal_MessageOptional')"
                            :isShowTitle="false"
                            rows="3"
                            v-model="messageToBuyer"
                            max="300"
                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        />
                    </div>
                </ValidationObserver>
            </template>

            <template v-slot:MiddleFooter>
                <b-button
                    variant="outline-secondary"
                    class="UserSetting_Cancel"
                    :t_label="`EMP3_SalesLead_NameCard_SendModal_Cancel_${rid || 0}`"
                    @click="showSendNameCardModal = false"
                >
                    {{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_Cancel") }}
                </b-button>
            </template>

            <template v-slot:RightFooter>
                <b-button
                    variant="primary"
                    :t_label="`EMP3_SalesLead_NameCard_SendModal_Confirm_${rid || 0}`"
                    @click="confirmSendNameCard"
                    class="UserSetting_Ok"
                    :disabled="contactPersonLoading || !contactPersonLoaded"
                >
                    {{ $t("lbl_EMPBE_SalesLead_NameCardPage_Modal_Reply") }}
                </b-button>
            </template>
        </ModalTips>

        <!-- Modal: View replied (Figma node 2983:23704) -->
        <ModalTips :id="'ViewRepliedNameCardModal'" v-model="showViewRepliedModal" :closeOnBackdrop="true">
            <template v-slot:Title>
                <div class="nc-replied-title">
                    <div class="nc-replied-title-text">{{ repliedButtonText }}</div>
                    <div class="nc-replied-subtitle">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_NameCardReplied_Subtitle") }}</div>
                    <button
                        type="button"
                        class="nc-replied-close"
                        @click="showViewRepliedModal = false"
                        aria-label="Close"
                        :t_label="`EMP3_SalesLead_NameCard_ViewReplied_Close_${rid || 0}`"
                    >
                        <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Close.svg" alt="关闭" width="24" height="24" />
                    </button>
                </div>
            </template>

            <template v-slot:Content>
                <div class="nc-replied-body">
                    <div class="nc-replied-preview-wrap">
                        <div class="nc-preview nc-preview-supplier">
                            <div class="nc-preview-body">
                                <div class="nc-preview-supplier-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_SupplierTag") }}</div>
                                <div class="nc-preview-content">
                                    <div>
                                        <div class="nc-preview-name" v-if="supplierCardName">{{ supplierCardName }}</div>
                                        <div class="nc-preview-job" v-if="supplierCardJob">{{ supplierCardJob }}</div>
                                    </div>
                                    <div>
                                        <div class="nc-preview-company" v-if="supplierCardCompany">{{ supplierCardCompany }}</div>
                                        <div class="nc-preview-line" v-if="supplierCardMobile">{{ supplierCardMobile }}</div>
                                        <div class="nc-preview-line" v-if="supplierCardEmail">{{ supplierCardEmail }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 供应商回复内容 -->
                    <div class="nc-replied-message" v-if="supplierReplyInfo?.replyMessage">
                        <div>    
                            <div class="nc-title-content-label">{{ $t("lbl_EMPBE_SalesLead_NameCardPage_MessageFromSupplier") }}</div>
                            <div class="nc-title-content-body">{{ supplierReplyInfo.replyMessage }}</div>
                        </div>
                    </div>

                    <div class="nc-replied-note">
                        {{ repliedNoteText }}
                    </div>
                </div>
            </template>
        </ModalTips>
    </b-overlay>
</template>

<script>
import ModalTips from '@/components/UserSetting/ModalTips.vue';
import unlockQuota_Free from './unlockQuota_Free.vue';
import MessageThread from '@/components/MessageBoard/MessageThread.vue';
import { formatSalesLeadDate } from '@/_helpers/formatSalesLeadDate';
import { formatSalesLeadTitleWithCountry } from '@/_helpers/formatSalesLeadTitleWithCountry';
 import { InquiryFormService, CompanyInfoService } from '../../../_services';

export default {
    props: {
        NameCardDetail: Object,
        loading: Boolean,
        mobile: Boolean,
        user: Object,
        rid: Number,
        simulatedSupplier: Object
    },
    inject: ["permissionData", "GetDetail"],
    components: {
        ModalTips,
        unlockQuota_Free,
        MessageThread
    },
    data() {
        return {
            showSendNameCardModal: false,
            showViewRepliedModal: false,
            selectedContactPerson: null,
            contactPersonOptionsData: [],
            contactPersonMap: {},
            contactPersonLoaded: false,
            supplierReplyInfo: null,  // 供应商回复的名片信息
            contactPersonLoading: false,
            messageToBuyer: '',
            localReplied: false,
            localRepliedBy: '',
            // Name Card image preview
            isShowNameCardImageModal: false,
            nameCardImagePreviewUrl: '',
            // Company lead 场景的公司 logo（当接口未直接带在 NameCardDetail 时拉取）
            leadSourceCompanyLogoUrl: null,
            // 免费账号 + 名片配额已用完时，由 unlockQuota_Free 通知的“锁定”状态
            isNameCardLockedByQuota: false
        }
    },
    watch: {
        // 每次切换到另一条名片详情时，重置本地“已回复”状态，避免影响其它记录的按钮显示
        NameCardDetail: {
            handler() {
                this.localReplied = false;
                this.localRepliedBy = '';
                this.supplierReplyInfo = null;
                this.leadSourceCompanyLogoUrl = null;
                this.loadLeadSourceCompanyLogo();
            },
            deep: false,
            immediate: true
        },
        user: {
            handler() {
                if (!this.isCompanyLead || this.leadSourceProductPhoto) return;
                this.leadSourceCompanyLogoUrl = null;
                this.loadLeadSourceCompanyLogo();
            },
            deep: false
        }
    },
    computed: {
        BoothType() {
            // `permissionData` is provided from parent as a computed ref in some pages.
            // Support both shapes: plain object and { value: object }.
            const pd = this.permissionData?.value || this.permissionData;
            const injectedType = pd?.Type;
            if (injectedType) return injectedType;

            // Fallback: infer from `user` (works even when inject/provide isn't available)
            const u = this.user || {};
            if (u.eBoothGrade) return u.eBoothGrade;
            if (Number(u.isMember) > 0) return 'Member';
            if (Number(u.isExhibitor) > 0) return 'Guest';
            return undefined;
        },
        isFreeBooth() {
            // 1) 优先使用详情接口返回的 isFreeBooth（来自 proc_SalesLead_GetNameCardDetail）
            if (this.NameCardDetail && typeof this.NameCardDetail.isFreeBooth !== 'undefined') {
                return this.NameCardDetail.isFreeBooth === 1 || this.NameCardDetail.isFreeBooth === true;
            }
            // 2) 兼容旧逻辑：从注入的 permissionData / user 推断 BoothType
            const pd = this.permissionData?.value || this.permissionData;
            const injectedType = pd?.Type;
            const boothType = injectedType
                || (this.user && this.user.eBoothGrade)
                || (Number(this.user?.isMember) > 0 ? 'Member' : undefined)
                || (Number(this.user?.isExhibitor) > 0 ? 'Guest' : undefined);
            if (!boothType) return false;
            return String(boothType).toLowerCase() === 'free';
        },
        unread() {
            return this.NameCardDetail?.readDate == '9999-12-31'
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        countryName() {
            if (!this.NameCardDetail) return '';
            switch (this.langId) {
                case '950':
                    return this.NameCardDetail?.countryName_trad
                case '1252':
                    return this.NameCardDetail?.countryName_eng
                default:
                    return this.NameCardDetail?.countryName_simp
            }
        },
        leadSourceProductName() {
            if (!this.NameCardDetail) return '';
            // Company lead 场景下后端可能不返回 productName，
            // 统一使用供应商公司名做兜底，避免落到买家字段。
            return this.NameCardDetail.productName
                || this.leadSourceCompanyName
                || '';
        },
        leadSourceCompanyName() {
            const u = this.user || {};
            const en = u.companyNameEn || '';
            const sc = u.companyNameSc || '';
            const tc = u.companyNameTc || '';
            if (String(this.langId) === '1252') return en || sc || tc || u.displayName || '';
            if (String(this.langId) === '950') return tc || sc || en || u.displayName || '';
            return sc || tc || en || u.displayName || '';
        },
        leadSourceProductPhotoRaw() {
            const d = this.NameCardDetail || {};
            if (d.productPhotoFilename) {
                return d.productPhotoFilename;
            }
            const authUser = this.$store?.state?.authentication?.user || {};
            const u = this.user || {};
            return (
                d.companyLogoUrl
                || d.companyLogo
                || d.logo
                || d.logoUrl
                || d.compLogo
                || d.compLogoUrl
                || d.companyLogoFileName
                || d.logoFileName
                || u.companyLogoUrl
                || u.companyLogo
                || u.logo
                || u.logoUrl
                || authUser.companyLogoUrl
                || authUser.companyLogo
                || authUser.logo
                || authUser.logoUrl
                || this.leadSourceCompanyLogoUrl
                || ''
            );
        },
        leadSourceProductPhoto() {
            return this.normalizeLeadSourcePhoto(this.leadSourceProductPhotoRaw);
        },
        leadSourceCompanyFirstChar() {
            if (!this.isCompanyLead) return '';
            const name = this.leadSourceProductName || this.leadSourceCompanyName || '';
            const plain = String(name).replace(/<[^>]+>/g, '');
            const cleaned = plain.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');
            if (cleaned.length) return cleaned[0];
            const trimmed = plain.trim();
            if (trimmed.length) return trimmed[0];
            return '';
        },
        productShareUrl() {
            // 需要产品ID + 公司ID 才能生成分享链接
            const productId = this.NameCardDetail?.productId;
            const companyId = this.leadSourceCompanyId;
            if (!productId || !companyId) return null;

            // 语言段：simp / trad / eng
            let langSegment = 'simp';
            switch (String(this.langId)) {
                case '950':
                    langSegment = 'trad';
                    break;
                case '1252':
                    langSegment = 'eng';
                    break;
                default:
                    langSegment = 'simp';
                    break;
            }

            // 使用环境变量配置的 eMarketplace 域名（例如 VUE_APP_EMP_VIEW）
            const base = process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/';
            return `${base}ProductInfo/${langSegment}?compid=${companyId}&SeqId=${productId}`;
        },
        leadSourceCompanyId() {
            return this.NameCardDetail?.empCompanyId
                || this.NameCardDetail?.companyId
                || this.NameCardDetail?.compId
                || this.NameCardDetail?.EmpCompanyId
                || this.user?.empCompanyId
                || null;
        },
        isCompanyLead() {
            return !this.NameCardDetail?.productId;
        },
        companyShareUrl() {
            const companyId = this.leadSourceCompanyId;
            if (!companyId) return null;
            let langSegment = 'simp';
            switch (String(this.langId)) {
                case '950':
                    langSegment = 'trad';
                    break;
                case '1252':
                    langSegment = 'eng';
                    break;
                default:
                    langSegment = 'simp';
                    break;
            }
            const base = process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/';
            return `${base}ExhibitorInfo/${langSegment}?compid=${companyId}`;
        },
        leadSourceTargetUrl() {
            return this.productShareUrl || this.companyShareUrl || null;
        },
        title() {
            if (!this.NameCardDetail) return '';
            const buyerName = this.NameCardDetail?.surname || '';
            const countryName = this.countryName || '';
            return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_NameCardPage_FromBuyerAndRegion', {
                buyerName,
                buyerCountryAndRegion: countryName,
            });
        },
        receivedOnText() {
            if (!this.NameCardDetail?.cdate) return '';
            const date = formatSalesLeadDate(this.NameCardDetail.cdate);
            return this.$t("lbl_EMPBE_SalesLead_NameCardPage_ReceivedOn").replace("{nameCardSentDate}", date);
        },
        refText() {
            if (!this.NameCardDetail?.uniqueCode) return '';
            return this.$t("lbl_EMPBE_SalesLead_NameCardPage_Ref").replace("{nameCardCode}", this.NameCardDetail.uniqueCode);
        },
        isReplied() {
            return !!(this.localReplied || this.NameCardDetail?.isReplied || this.NameCardDetail?.repliedBy);
        },
        // 当前这条名片是否已经通过解锁配额“解锁”过（基于 proc_SalesLead_GetNameCardDetail 返回的 isUnLocked/canReplyNameCard）
        isNameCardUnlocked() {
            const d = this.NameCardDetail || {};
            // 后端脚本返回 isUnLocked / canReplyNameCard 两个字段，任一为 true 即视为已解锁可回复
            if (typeof d.isUnLocked !== 'undefined') {
                if (d.isUnLocked === 1 || d.isUnLocked === true) return true;
            }
            if (typeof d.canReplyNameCard !== 'undefined') {
                if (d.canReplyNameCard === 1 || d.canReplyNameCard === true) return true;
            }
            return false;
        },
        /** 列表与「已回复」按钮仅展示状态文案，不含联系人姓名 */
        repliedButtonText() {
            return this.$t('lbl_EMPBE_SalesLead_NameCardPage_NameCardReplied_StatusOnly');
        },
        isAutoReplied() {
            const d = this.NameCardDetail || {};
            const value =
                d.isAutoReply
                ?? d.IsAutoReply
                ?? d.isautoreply
                ?? 0;
            return value === 1 || value === true || String(value) === '1';
        },
        repliedNoteText() {
            if (this.isAutoReplied) {
                return this.$t("lbl_EMPBE_SalesLead_NameCardReplied_Note_Auto");
            }

            const sender =
                (this.supplierReplyInfo?.personName || '').trim()
                || (this.NameCardDetail?.repliedByName || '').trim()
                || (this.NameCardDetail?.sentBy || '').trim()
                || (this.localRepliedBy || '').trim();

            if (sender) {
                return this.$t("lbl_EMPBE_SalesLead_NameCardReplied_Note").replace("{nameOfNameCardExchanged}", sender);
            }
            return this.$t("lbl_EMPBE_SalesLead_NameCardReplied_Note_Auto");
        },
        contactPersonOptions() {
            // treeselect expects { id, label } objects
            return this.contactPersonOptionsData || [];
        },
        selectedContactPersonInfo() {
            const key = String(this.selectedContactPerson || '');
            return this.contactPersonMap?.[key] || null;
        },
        isContactPersonSelected() {
            return !!this.selectedContactPersonInfo;
        },
        isSelectedContactPersonMyAccount() {
            // 判断选择的联系人是否是当前用户自己的账号
            if (!this.selectedContactPerson) return false;
            
            const storeUser = this.$store?.state?.authentication?.user || {};
            const currentAccountUserId =
                storeUser?.accountUserId
                || storeUser?.AccountUserId
                || this.user?.accountUserId
                || this.user?.AccountUserId
                || this.user?.accountUserID
                || this.user?.AccountUserID
                || 0;
            
            const selectedInfo = this.selectedContactPersonInfo;
            if (!selectedInfo) return false;
            
            const selectedAccountUserId = selectedInfo?.accountUserId ?? selectedInfo?.AccountUserId;
            return String(selectedAccountUserId) === String(currentAccountUserId);
        },
        showReplyWithNameCardButton() {
            // 规则汇总：
            // 1）已回复：不允许再次回复
            if (this.isReplied) {
                return false;
            }
            // 2）免费账号且名片配额已用完（由 unlockQuota_Free 通知）：不显示按钮，仅显示锁定态
            if (this.isNameCardLockedByQuota) {
                return false;
            }
            // 3）免费展台：只有当当前这条名片已解锁时才显示“Reply with Name Card”
            if (this.isFreeBooth && !this.isNameCardUnlocked) {
                return false;
            }
            // 4）其他情况（非免费账号，或免费账号但仍有配额 / 已解锁）：可以显示“Reply with Name Card”
            return true;
        },
        supplierCardName() {
            // 如果已回复且已加载供应商回复信息，使用从接口获取的供应商回复名片数据
            if (this.isReplied && this.supplierReplyInfo?.personName) {
                return this.supplierReplyInfo.personName;
            }
            // 未选择联系人时，显示字段文案占位，避免误导为真实联系人资料
            if (!this.isContactPersonSelected) {
                return this.$t('lbl_EMPBE_SalesLead_Name');
            }
            // 否则使用联系人信息（已选联系人时不显示「名称」等基底占位字）
            const u = this.selectedContactPersonInfo || {};
            return u?.personName || u?.displayName || u?.personNameEn || u?.personNameSc || u?.userName || u?.name || '';
        },
        supplierCardJob() {
            // 如果已回复且已加载供应商回复信息，使用从接口获取的供应商回复名片数据
            if (this.isReplied && this.supplierReplyInfo?.jobTitle) {
                return this.supplierReplyInfo.jobTitle;
            }
            if (!this.isContactPersonSelected) {
                return this.$t('lbl_EMPBE_SalesLead_JobTitle');
            }
            // 否则使用联系人信息
            const u = this.selectedContactPersonInfo || {};
            return u?.jobTitle || u?.jobTitleEn || u?.jobTitleSc || u?.jobTitleTc || '';
        },
        supplierCardCompany() {
            // 如果已回复且已加载供应商回复信息，使用从接口获取的供应商回复名片数据
            if (this.isReplied && this.supplierReplyInfo?.companyName) {
                return this.supplierReplyInfo.companyName;
            }
            if (!this.isContactPersonSelected) {
                return this.$t('lbl_EMPBE_SalesLead_NameCardPage_CompanyName');
            }
            // 否则使用联系人信息
            const u = this.selectedContactPersonInfo || {};
            return u?.companyName || this.user?.companyName || this.user?.compName || this.user?.compname || '';
        },
        supplierCardMobile() {
            // 如果已回复且已加载供应商回复信息，使用从接口获取的供应商回复名片数据
            if (this.isReplied) {
                return this.supplierReplyInfo?.phone
                    ? this.formatPhoneWithCountryCode(this.supplierReplyInfo)
                    : '';
            }
            if (!this.isContactPersonSelected) {
                return this.$t('lbl_EMPBE_SalesLead_NameCardPage_MobileNo');
            }
            // 否则使用联系人信息（GetNameCardReplyContacts 返回 phoneCountry + phoneValue）
            const u = this.selectedContactPersonInfo || {};
            const formatted = this.formatPhoneWithCountryCode({
                ...u,
                phone: u?.phoneValue || u?.mobile || u?.tel || ''
            });
            return formatted || '';
        },
        supplierCardEmail() {
            // 如果已回复且已加载供应商回复信息，使用从接口获取的供应商回复名片数据
            if (this.isReplied) {
                return this.supplierReplyInfo?.email || '';
            }
            if (!this.isContactPersonSelected) {
                return this.$t('lbl_EMPBE_SalesLead_NameCardPage_EmailAddress');
            }
            // 否则使用联系人信息（已选联系人时无邮箱则不显示基底占位字）
            const u = this.selectedContactPersonInfo || {};
            return u?.emailValue || u?.email || '';
        },
        attachmentThumbSrc() {
            // Prefer dedicated attachment thumbnail if backend provides it; fallback to the main name card image.
            return this.NameCardDetail?.nameCardImage
                || '';
        },
        websiteHref() {
            const raw = this.NameCardDetail?.website || '';
            if (!raw) return '';
            if (/^https?:\/\//i.test(raw)) return raw;
            return `https://${raw}`;
        }
    },
    methods: {
        openLeadSourceLink() {
            if (!this.leadSourceTargetUrl) return;
            window.open(this.leadSourceTargetUrl, '_blank', 'noopener');
        },
        normalizeLeadSourcePhoto(raw) {
            const value = String(raw || '').trim();
            if (!value) return '';
            let url = value;
            if (!/^(https?:)?\/\//i.test(url) && !url.startsWith('data:') && !url.startsWith('blob:')) {
                const ossOrigin = String(process.env.VUE_APP_OSS_ORIGIN || '').trim();
                if (ossOrigin) {
                    const base = ossOrigin.endsWith('/') ? ossOrigin : `${ossOrigin}/`;
                    url = `${base}${url.replace(/^\/+/, '')}`;
                } else {
                    url = `https://cdn.adsalecdn.com/${url.replace(/^\/+/, '')}`;
                }
            }
            const sep = url.includes('?') ? '&' : '?';
            return `${url}${sep}x-oss-process=image/resize,w_100/format,webp`;
        },
        async fetchCompanyLogoFileName(companyId) {
            const logoRes = await CompanyInfoService.GetCompanyLogo(companyId);
            const directLogo = String(logoRes?.data || '').trim();
            if (directLogo) return directLogo;

            const infoRes = await CompanyInfoService.GetCompanyInfoAsync({ companyId, showTemp: false });
            if (!infoRes?.isSuccessful) return '';
            const mediaList = infoRes?.data?.mediaFileList || infoRes?.data?.MediaFileList || [];
            const logoItem = mediaList.find(
                (item) => String(item?.usageType || item?.UsageType || '').toLowerCase() === 'companylogo'
            );
            return String(logoItem?.fileName || logoItem?.FileName || '').trim();
        },
        async loadLeadSourceCompanyLogo() {
            const d = this.NameCardDetail || {};
            if (!d || d.productId) return;
            if (this.leadSourceCompanyLogoUrl) return;

            const companyId = this.leadSourceCompanyId;
            if (!companyId) return;

            if (this.normalizeLeadSourcePhoto(this.leadSourceProductPhotoRaw)) return;

            try {
                const logo = await this.fetchCompanyLogoFileName(companyId);
                if (logo) {
                    this.leadSourceCompanyLogoUrl = logo;
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('loadLeadSourceCompanyLogo failed:', e);
            }
        },
        onNameCardUnlockQuota(isLockedByQuota) {
            // unlockQuota_Free 约定：只有在「当前条目仍锁定 && YearRemainingQuota == 0」时才会传 true
            // 这里直接将其视为“免费账号的名片额度已用完，且该条 NameCard 仍处于锁定”。
            this.isNameCardLockedByQuota = !!isLockedByQuota;
        },
        openNameCardImagePreview() {
            if (!this.attachmentThumbSrc) return;
            this.nameCardImagePreviewUrl = this.attachmentThumbSrc;
            this.isShowNameCardImageModal = true;
        },
        formatPhoneWithCountryCode(replyInfo) {
            const phoneRaw = String(replyInfo?.phone || '').trim();
            if (!phoneRaw) return '';

            // 兼容后台可能返回的不同字段命名
            const countryRaw =
                replyInfo?.phoneCountryId
                ?? replyInfo?.PhoneCountryId
                ?? replyInfo?.phoneCountry
                ?? replyInfo?.PhoneCountry
                ?? replyInfo?.countryCode
                ?? replyInfo?.CountryCode
                ?? replyInfo?.dialCode
                ?? replyInfo?.DialCode
                ?? replyInfo?.telCountry
                ?? replyInfo?.TelCountry
                ?? replyInfo?.countryId
                ?? replyInfo?.CountryId
                ?? replyInfo?.contactPhoneCountryCode
                ?? '';
            const country = String(countryRaw || '').trim().replace(/^\+/, '');
            const phoneNoPlus = phoneRaw.replace(/^\+/, '');

            if (!country) {
                return phoneRaw;
            }

            // 避免重复拼接区号（例如 phone 已是 852xxxx 或 +852xxxx）
            if (phoneNoPlus.startsWith(country)) {
                const rest = phoneNoPlus.slice(country.length).trim();
                return rest ? `+${country} ${rest}` : `+${country}`;
            }

            return `+${country} ${phoneNoPlus}`;
        },
        async openSendNameCardModal() {
            this.messageToBuyer = '';
            this.showSendNameCardModal = true;
            await this.fetchContactPersonOptions();
        },
        async openViewRepliedModal() {
            this.showViewRepliedModal = true;
            // 调用新接口获取供应商回复的名片信息
            if (this.rid && this.isReplied) {
                try {
                    const result = await InquiryFormService.GetSupplierReplyNameCard(this.rid);
                    // service 返回的已经是 res.data，所以 result 就是数据对象
                    if (result && (result.personName || result.companyName || result.email)) {
                        this.supplierReplyInfo = result;
                    } else {
                        this.supplierReplyInfo = null;
                    }
                } catch (error) {
                    console.error('GetSupplierReplyNameCard error:', error);
                    this.supplierReplyInfo = null;
                }
            }
        },
        async fetchContactPersonOptions() {
            if (this.contactPersonLoaded || this.contactPersonLoading) return;
            if (this.simulatedSupplier) {
                // keep simple for simulated supplier mode
                this.contactPersonLoaded = true;
                return;
            }
            this.contactPersonLoading = true;
            try {
                // 使用新的 NameCard 回复联系人接口
                const langId = parseInt(this.langId) || 1252;
                const list = await InquiryFormService.GetNameCardReplyContacts(langId) || [];

                const storeUser = this.$store?.state?.authentication?.user || {};
                const currentAccountUserId =
                    storeUser?.accountUserId
                    || storeUser?.AccountUserId
                    || this.user?.accountUserId
                    || this.user?.AccountUserId
                    || this.user?.accountUserID
                    || this.user?.AccountUserID
                    || 0;

                // 识别当前用户（用于自动选中）
                const selfUser = list.find(u => String(u?.accountUserId ?? u?.id) === String(currentAccountUserId));
                const selfId = selfUser ? String(selfUser?.accountUserId ?? selfUser?.id) : null;
                // 识别展台代表（优先默认选中）
                const eBoothRepresentativeIdRaw = list.find(u => u?.eBoothRepresentativeId)?.eBoothRepresentativeId;
                const eBoothRepresentativeId =
                    (eBoothRepresentativeIdRaw === null || eBoothRepresentativeIdRaw === undefined || eBoothRepresentativeIdRaw === '')
                        ? null
                        : String(eBoothRepresentativeIdRaw);

                // Build map + options（新接口已经返回了 id 和 label）
                const map = {};
                const options = [];

                list.forEach(u => {
                    const key = String(u?.accountUserId ?? u?.id ?? '');
                    if (!key || !u?.label) return;
                    
                    // 存储完整联系人信息（包含名片预览所需的所有字段）
                    map[key] = u;
                    options.push({ 
                        id: key, 
                        label: u.label || u.displayName || ''
                    });
                });

                // 确保当前用户排在第一位
                if (selfUser) {
                    const key = String(selfId || '');
                    const withoutSelf = options.filter(x => String(x.id) !== key);
                    options.splice(0, options.length, { id: key, label: selfUser.label || selfUser.displayName || '' }, ...withoutSelf);
                }

                this.contactPersonOptionsData = options;
                this.contactPersonMap = map;
                this.contactPersonLoaded = true;

                // 默认选择优先级：展台代表 > 当前用户（自己）
                const validIds = new Set((options || []).map(o => String(o.id)));
                const current = String(this.selectedContactPerson || '');
                if (!current || !validIds.has(current)) {
                    if (eBoothRepresentativeId && validIds.has(eBoothRepresentativeId)) {
                        this.selectedContactPerson = eBoothRepresentativeId;
                    } else {
                        this.selectedContactPerson = selfUser ? String(selfId) : null;
                    }
                }
            } catch (e) {
                console.error('Failed to fetch contact person options:', e);
                // No fallback/default options here; keep empty when API fails.
                this.contactPersonOptionsData = [];
                this.contactPersonMap = {};
                this.contactPersonLoaded = true;
            } finally {
                this.contactPersonLoading = false;
            }
        },
        async confirmSendNameCard() {
            if (this.contactPersonLoading || !this.contactPersonLoaded) {
                return;
            }
            const observer = this.$refs.sendNameCardFormObserver;
            if (observer) {
                const ok = await observer.validate();
                if (!ok) {
                    return;
                }
            }
            if (!this.isContactPersonSelected) {
                return;
            }

            try {
                const payload = {
                    nameCardRequestId: this.rid,
                    roleId: Number(this.selectedContactPerson),
                    replyMessage: this.messageToBuyer || '',
                    langId: this.langId ? parseInt(this.langId) : null  // 如果语言ID存在则传递，否则传 null（后端会使用名片的语言ID）
                };

                const result = await InquiryFormService.ReplyNameCard(payload);

                // 后端返回存储过程的 Result（>0 表示成功，其它为错误码）
                if (typeof result === 'number' && result > 0) {
                this.localReplied = true;
                this.localRepliedBy = result.data;
                this.showSendNameCardModal = false;

                this.GetDetail();
                } else {
                    // 失败时先简单打日志，后续可根据不同错误码做精细提示
                    // -1: 未找到 NameCardRequest
                    // -2: 未找到联系人
                    // -3/-4: 收件人邮箱异常
                    // 保持 UI 不变，让用户可以重试
                    // eslint-disable-next-line no-console
                    console.error('ReplyNameCard failed with code:', result);
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('ReplyNameCard error:', e);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/* === Strictly aligned to Figma node 3119:42498 === */
.nc-tray {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 24px;
    background: #FFFFFF;
    box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);
    padding: 24px;
}

.nc-mobile {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
}

.nc-mobile .nc-title-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
}

.nc-mobile .nc-title-left {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
}

.nc-mobile .nc-title-line {
    flex: 1 1 auto;
    width: 100%;
}

.nc-mobile .nc-title-right {
    width: 100%;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2px;
}

.nc-mobile .nc-title-text {
    flex: 1 1 auto;
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
}

.nc-mobile .nc-received,
.nc-mobile .nc-ref {
    width: 100%;
    text-align: left;
}

/* Super admin (simulatedSupplier) should also use mobile-like vertical layout */
.nc-mobile .nc-content-inner {
    grid-template-columns: 1fr;
}

.nc-mobile .nc-contact,
.nc-mobile .nc-master {
    min-width: 100%;
}

.nc-title-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
}

.nc-unLock{
    width: 100%;
}

.nc-title-left {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex: 1 1 0;
    min-width: 0;
    max-width: 100%;
}

.nc-back {
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: inline-flex;
}

.nc-title-line {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
}

.nc-title-text {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.22px;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
}

.nc-unread-chip {
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 125px;
    background: #7366FF;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 150%;
    flex-shrink: 0;
}

.nc-title-right {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
    align-items: flex-start;
    flex-shrink: 0;
}

.nc-received {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}

.nc-ref {
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}

.nc-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    padding: 8px 16px;
    border-radius: 16px;
    background: #F2F3F5;
}

.nc-content-inner {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(260px, min(420px, 100%));
    gap: 16px;
    align-self: stretch;
    padding: 8px 0px;
}

/* 与「立即查询」一致：按右侧详情区宽度（container）收窄时自动改为上下布局，而非只看整页视口宽度 */
@container (max-width: 800px) {
    .nc-content-inner {
        grid-template-columns: 1fr;
    }

    .nc-contact,
    .nc-master {
        min-width: 100%;
    }
}

.nc-master {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
}

.nc-contact {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.nc-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.nc-section-title {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
}

.nc-card {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 16px;
    align-self: stretch;
    background: #FFFFFF;
    border: 1px solid #F2F3F5;
    border-radius: 8px;
}

.nc-card--clickable {
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.nc-card--clickable:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
}

.nc-namecard-preview-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    width: 100%;
}

.nc-preview {
    position: relative;
    width: min(100%, 322px);
    aspect-ratio: 322 / 192;
    height: auto;
    max-width: 100%;
    border-radius: 8px;
    /* Figma：名片封面底色 */
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.60) 100%),
        radial-gradient(125.58% 74.12% at 67.08% 27.5%, #FEF2DF 0%, #FFF 58.44%, rgba(255, 196, 102, 0.60) 100%),
        #FFF;
    border: 0.5px solid rgba(226, 226, 226, 1);
    box-shadow: 0px 2.4px 18px 0px rgba(183, 183, 183, 0.30);
    /* 允许右下角缩略图略微“溢出”卡片边界，以符合 Figma 设计 */
    overflow: visible;
}

/* 供应商侧名片预览（回复弹窗等）：保留原红色系渐变，与买家 Figma 渐变区分 */
.nc-preview-supplier {
    background: radial-gradient(circle at 67% 27%,
            rgba(253, 232, 232, 1) 0%,
            rgba(255, 255, 255, 1) 58%,
            rgba(255, 105, 105, 0.40) 100%);
}

.nc-preview-supplier-label {
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    background: linear-gradient(90deg, rgba(203, 36, 43, 1) 0%, rgba(237, 129, 133, 1) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    flex-shrink: 0;
}

.nc-preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.nc-preview-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    padding: 20px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
    overflow: hidden;
}

.nc-preview-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1;
    height: 152px;
    margin-left: 0;
    min-width: 0;
    overflow: hidden;
}

.nc-preview-content > div:first-child {
    flex-shrink: 1;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

.nc-preview-content > div:last-child {
    flex-shrink: 1;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

/* Buyer / Supplier name card lines vertical gap = 4px（Figma spec） */
.nc-preview-content > div {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    min-width: 0;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
}

.nc-preview-name {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 115%;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* Full name - max 2 lines */
    line-clamp: 2;
    word-break: break-word;
    overflow-wrap: break-word;
}

.nc-preview-job {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 110%;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* Job title - max 2 lines */
    line-clamp: 2;
    word-break: break-word;
    overflow-wrap: break-word;
}

.nc-preview-company {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.24px;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* Company name - max 2 lines */
    line-clamp: 2;
    word-break: break-word;
    overflow-wrap: break-word;
}

/* Mobile no. - max 1 line */
.nc-preview-line {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 11px;
    font-weight: 400;
    line-height: 110%;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Email address - max 2 lines */
.nc-preview-email {
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    word-break: break-word;
    overflow-wrap: break-word;
}

.nc-preview-buyer {
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    background: linear-gradient(90deg, rgba(233, 128, 36, 1) 0%, rgba(255, 203, 157, 1) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    flex-shrink: 0;
}

.nc-preview-attach {
    position: absolute;
    /* Figma position: x=276,y=146 within 322x192 => right/bottom = -14px (overhang) */
    right: -14px;
    bottom: -14px;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.nc-preview-attach img,
.nc-preview-attach-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
}

.nc-preview-attach-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nc-title-content-label {
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
}

.nc-title-content-body {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.nc-product-row {
    display: flex;
    align-items: center;
    gap: 16px;
}

.nc-product-thumb {
    width: 96px;
    height: 96px;
    border-radius: 6px;
    background: #F9F9F9;
    border: 0.5px solid rgba(0, 0, 0, 0.05);
    overflow: hidden;
    flex: 0 0 auto;
}

.nc-product-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.nc-product-thumb--company {
    border-radius: 9999px;
}

.nc-company-thumb-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.2);
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: -0.264px;
}

.nc-product-title {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
}

.nc-product-title-text {
    color: rgba(0, 0, 0, 0.80);
    font-size: 16px;
    font-weight: 500;
    line-height: 20.80px;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.nc-actions-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    min-width: 0;
}

.nc-btn {
    display: inline-flex;
    align-items: center;
    /* 控制高度对齐设计稿（避免不同浏览器 line-height 造成按钮偏大） */
    height: 32px;
    padding: 0 8px;
    border-radius: 4px;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.15px;
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;
}

.nc-btn-done {
    /* Default: filled green pill (Figma “Replied / Default”) */
    border: 1px solid #51BB25;
    background: #51BB25;
    color: #FFFFFF;
    flex-shrink: 0;
    min-width: 0;
}

/* Replied 按钮内图标与文字的间距 */
.nc-btn-done .nc-btn-icon {
    margin-right: 4px;
    flex-shrink: 0;
}

/* 让 “Replied” 按钮里的 SVG 图标始终以白色显示 */
.nc-btn-done .nc-btn-icon img {
    filter: brightness(0) invert(1);
}

/* Replied 按钮文字过长时显示省略号 */
.nc-btn-done .nc-btn-text {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.nc-btn-reply {
    /* Default: purple filled (Figma “Not yet replied / Default”) */
    background: rgba(121, 104, 255, 1); /* #7968FF */
    border: 1px solid rgba(121, 104, 255, 1);
    color: #FFFFFF;
    /* 与右侧说明同排时勿被 flex 压窄导致英文折行 */
    flex-shrink: 0;
    white-space: nowrap;
}

.nc-btn-reply-locked {
    border-color: #9EA5A8;
    background: #9EA5A8;
    color: #FFFFFF;
    flex-shrink: 0;
    white-space: nowrap;
}

.nc-btn-reply-locked .nc-btn-icon svg path {
    fill: #FFFFFF;
}
.nc-btn-reply-locked .nc-btn-icon{
    display: flex;
    align-items: center;
    justify-content: center;
}
.nc-btn:disabled {
    opacity: 1;
    cursor: default;
}

/* Hovering states（参考设计第二排 Hovering） */
.nc-btn-done:hover {
    /* 轻微高亮即可，避免太突兀 */
    background: #5ED62C;
    border-color: #5ED62C;
}

.nc-btn-reply:hover:not(.nc-btn-reply-locked):not(:disabled) {
    background: rgba(68, 51, 255, 1); /* Hover: deeper purple */
    border-color: rgba(68, 51, 255, 1);
    color: #FFFFFF;
}

.nc-actions-slash {
    color: rgba(0, 0, 0, 0.20);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
}

.nc-actions-tip {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    flex: 1 1 160px;
    min-width: 0;
}

.nc-contact-card {
    gap: 20px;
    padding: 20px;
    align-items: center;
}

.nc-contact-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;
}

.nc-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
}

.nc-row-label {
    width: 140px;
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    flex: 0 0 auto;
}

.nc-row-value {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    flex: 1 1 0;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.nc-link {
    color: #2C6ECB;
    text-decoration: none;
}

.nc-link:hover {
    text-decoration: none;
}

.nc-contact-foot {
    align-self: stretch;
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
}

@media screen and (max-width: 768px) {
    .nc-content-inner {
        grid-template-columns: 1fr;
    }

    .nc-contact,
    .nc-master {
        min-width: 100%;
    }
}

/* ===== Modal (Send My Name Card) ===== */
.nc-modal-title-text {
    color: rgba(0, 0, 0, 0.80);
    font-size: 18px;
    font-weight: 700;
    line-height: 130%;
}

.nc-modal-subtitle {
    color: rgba(0, 0, 0, 0.60);
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    margin-top: 4px;
}

.nc-modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: rgba(0, 0, 0, 0.80);
}

.nc-modal-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.nc-modal-label {
    color: rgba(0, 0, 0, 0.40);
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
}

.nc-modal-hint {
    color: rgba(0, 0, 0, 0.40);
    font-size: 12px;
    line-height: 150%;
}

.nc-modal-link {
    color: #2C6ECB;
    text-decoration: none;
}

.nc-modal-link:hover {
    text-decoration: none;
}

.nc-modal-preview-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px 0px;
}

.nc-edit-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #2C6ECB;
    text-decoration: none;
    font-size: 12px;
}

.nc-edit-link:hover {
    text-decoration: none;
}

.nc-modal-textarea {
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    padding: 8px 12px;
    font-size: 14px;
    resize: vertical;
}

/* 同步 UserSettingTips.vue Footer Buttons 样式（scoped，避免影响其他地方） */
.UserSetting_Ok {
    padding: 0.375rem 1.75rem !important;
    line-height: 1.5 !important;
    border-radius: 0.25rem !important;
    font-size: 14px !important;
    font-family: Inter, sans-serif !important;
    font-weight: 700 !important;
    box-shadow: none !important;
    border: none !important;
    background: #7366FF !important;
}

.UserSetting_Ok:hover:not(:disabled) {
    background: #4433FF !important;
}

.UserSetting_Ok:focus,
.UserSetting_Ok:active {
    box-shadow: none !important;
}

.UserSetting_Ok:disabled,
.UserSetting_Ok.disabled {
    background: #9EA5A8 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
}

.UserSetting_Cancel {
    padding: 0.375rem 1.75rem !important;
    line-height: 1.5 !important;
    border-radius: 0.25rem !important;
    border: none !important;
    background: transparent !important;
    color: rgba(0, 18, 26, 0.60) !important;
    font-size: 14px !important;
    font-family: Inter, sans-serif !important;
    font-weight: 700 !important;
    text-decoration: none !important;
    box-shadow: none !important;
}

.UserSetting_Cancel:hover:not(:disabled):not(.disabled),
.UserSetting_Cancel:focus:not(:disabled):not(.disabled),
.UserSetting_Cancel:active:not(:disabled):not(.disabled) {
    background: rgba(0, 18, 26, 0.05) !important;
    color: rgba(0, 18, 26, 0.60) !important;
    text-decoration: none !important;
    border: none !important;
    box-shadow: none !important;
}

.UserSetting_Cancel:disabled,
.UserSetting_Cancel.disabled {
    background: transparent !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
}

/* ===== View replied modal (Figma node 2983:23704) ===== */
.nc-replied-title {
    position: relative;
    padding-right: 40px;
    min-width: 0;
    overflow: hidden;
}

.nc-replied-title-text {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    width: 100%;
}

.nc-replied-subtitle {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.6);
}

.nc-replied-close {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 32px;
    height: 32px;
    padding: 4px;
    border: none;
    background: transparent;
    cursor: pointer;
}

.nc-replied-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 16px 0;
}

.nc-replied-preview-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
}

.nc-replied-note,.nc-replied-message {
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.4);
    word-wrap: break-word;
}

/* Hide footer for this modal (design has no footer) */
::v-deep #ViewRepliedNameCardModal___BV_modal_body_ .Modal-Footer {
    display: none !important;
}

/* 留言由 MessageThread 自带白底与边框，外层仅作布局容器 */
.nc-card.nc-message-board-card {
    padding: 0;
    gap: 0;
    background: transparent;
    border: none;
}

.nc-section--remarks {
    margin-top: 16px;
}

.nc-message-board-card ::v-deep .message-thread {
    gap: 12px;
}

.nc-mobile .nc-card:not(.nc-message-board-card),
.nc-mobile .nc-unLock,
.nc-section--remarks ::v-deep .message-thread {
    box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
}

</style>

